export default __webpack_public_path__ + "static/2-0cd52e41f96e93fbc487205b80d11250.jpg";